






import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "affiliates-provider": () =>
      import("@/components/app/global/affiliate/affiliatesProvider.vue"),
    "affiliates-table": () =>
      import("@/components/app/global/affiliate/affiliatesTable.vue")
  }
})
export default class AdminAffiliatesList extends Vue {}
